<!--
   Invite contact btn in navbar
-->
<script setup lang="ts">
/* COMPONENTS */
import { ALIconButton } from '@af-lib/vue-ui';
import { computed } from 'vue';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/stores/auth';

const authStore = useAuthStore();
const router = useRouter();

const hasReachedContactInvitationLimit = computed(() => authStore.hasReachedContactInvitationLimit);
</script>

<template>
  <ALIconButton
    variant="tertiary"
    :isDisabled="hasReachedContactInvitationLimit"
    icon="fas fa-user-plus"
    :label="
      hasReachedContactInvitationLimit
        ? $t('recruiter_network.invite.limit.tooltip')
        : $t('recruiter_network.list.invite')
    "
    :shouldTeleportTooltip="true"
    @click="router.push({ name: 'network-invite' })"
  />
</template>
